import Vue from 'vue'
import VueRouter from 'vue-router'
import RouterPC from './routerPC'
import RouterMobile from './routerMobile'

Vue.use(VueRouter)


function isMobile() {
  return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(navigator.userAgent);
}


const router = new VueRouter({
  routes: isMobile() ? RouterMobile : RouterPC
})

export default router
